module.exports = __webpack_public_path__ + "img/placeholder_avatar.712c67ff.png";